export const VALIDATE_SPECIAL_EVENT = '[Special event] validation';
export const INVOKE_SPECIAL_EVENT = '[Special event] invoke';
